<!-- DDCFB New File-->
<div class="flyout">
  <div
    [style.top.px]="flyOutPositionHeight"
    class="loggedin-flyout flyout-main-container loggedin-flyout-user-modal mt-lg-0 border-top-0"
  >
    <div class="container container-wrapper">
      <div
        [style.top.px]="flyOutPositionHeight"
        class="flyout-content content content-loggedIn content-loggedIn-user-modal"
      >
        <div
          class="loggedin-modal loggedin-user-modal"
          role="dialog"
          tabindex="0"
        >
          <div class="loggedin-container">
            <div class="modal-content mt-lg-0 border-top-0">
              <div class="loggedIn-feed feed-header feed-header-fixed bg-dark">
                <div class="text-right">
                  <a
                    (click)="close()"
                    class="bg-dark flyout-close-accountpicker"
                    href="javascript:void(0);"
                    role="button"
                  >
                    Close
                  </a>
                </div>
              </div>
              <div
                class="modal-body picker-modal-body pl-0 pr-0"
                *ngIf="!showNewProfileSelector"
              >
                <ngc-user-accounts
                  (accountSwitch)="close()"
                  [corpInfoDetails]="corpInfoDetails"
                  [resUserAccountsContent]="flyoutContent"
                ></ngc-user-accounts>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
